import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import isEqual from 'lodash/isEqual';
import {Pagination, Table} from 'antd';
import { withWindowSize } from 'air-with-window-size';

import './ClientsTable.css';
import Button from "antd/es/button";
import AirModal from "../../../../../common/components/AirModal";
import {api} from "../../../../../services";
import {CarsQueueIcon} from "../../../../../common/icons";
import AirButton from "../../../../../common/components/AirButton";
import { odometerHelper } from '../../../../../helpers';
import CarPlateField from "./CarPlateField";

const pageSizeDefault = 7;
const pageSizeAlternative = 5;

@inject('commonStore', 'translationsStore', 'carsStore', 'groupsStore')
@observer
class ClientsTable extends Component {
  constructor(props) {
    super(props);
    this.defaultPageSize = 1;
    const dataSource = this.buildDataSourceWithKeys(this.props.cars);
    const pageSize = this.defaultPageSize;

    let pagination = false;
    let paginationText = '';
    this.state = {
      dataSourceBuffer: dataSource,
      selectedRowKeys: [],
      pageSize,
      pagination,
      paginationText
    };
  }

  handleRemoveCarFromGroup = () => {
    this.setState({removeLoading: true})
    api('remove vehicles from group', [this.state.carToRemove.id])
      .then(async () => await Promise.all([this.props.carsStore.loadMinimal(), this.props.carsStore.loadGroupsCount()]))
      .finally(() => {
        this.setState({
          confirmVisible: false,
          carToRemove: undefined,
          removeLoading: false
        })
      })
  }

  componentDidMount = () => {
    const dataSource = this.buildDataSourceWithKeys(this.props.cars);
    if (!isEqual(dataSource, this.state.dataSourceBuffer) || (dataSource.length > 0 && !this.state.pagination)) {
      this.buildPagination();
      this.props.carsStore.resetFilters();
    }
  };

  componentDidUpdate(prevProps) {
    const someSizeChanged = prevProps.componentHeight !== this.props.componentHeight || prevProps.windowHeight !== this.props.windowHeight;
    const dataSource = this.buildDataSourceWithKeys(this.props.cars);
    if (someSizeChanged || !isEqual(dataSource, this.state.dataSourceBuffer) || (dataSource.length > 0 && !this.state.pagination)) {
      this.buildPagination();
    }
  }

  helperPageSize = () => {
    const defaultDocHeight = 800;
    if (this.props.documentHeight === defaultDocHeight) {
      return !this.props.group ? pageSizeDefault : pageSizeAlternative;
    } else {
      return !this.props.group
        ? Math.floor((this.props.documentHeight * pageSizeDefault) / defaultDocHeight)
        : Math.floor((this.props.documentHeight * pageSizeAlternative) / defaultDocHeight);
    }
  };

  changePageSize = pageSize => {
    this.setState({ pageSize });
  };

  helperPaginationText = (start, end, length) => {
    const { translationsStore } = this.props;
    if (length === 0) return `0 ${translationsStore.translate('vehicles')}`;
    else if (length === 1) return `1 ${translationsStore.translate('vehicle')}`;
    else return `${start}-${end} ${translationsStore.translate('of')} ${length} ${translationsStore.translate('vehicles')}`;
  };

  buildDataSourceWithKeys = collection => collection.map((item, index) => ({ ...item, key: index }));

  buildSelectedRowKeys = (dataSource, selectedRows) => {
    let selectedRowKeys = [];
    dataSource.forEach((row, index) => {
      if (typeof selectedRows.find(selected => selected.id === row.id) !== 'undefined') selectedRowKeys.push(index);
    });
    return selectedRowKeys;
  };

  toggleSelectAllRows = () => {
    const { cars, onSelectedRowsChange } = this.props;
    let { selectedRows } = this.props;

    const dataSource = this.buildDataSourceWithKeys(cars);
    let selectedRowKeys = this.buildSelectedRowKeys(dataSource, selectedRows);

    if (selectedRowKeys.length > 0 && selectedRowKeys.length === dataSource.length) {
      selectedRows = [];
    } else {
      selectedRows = dataSource;
    }
    selectedRowKeys = selectedRows.map(row => row.key);
    onSelectedRowsChange(selectedRows);
    this.setState({ selectedRowKeys });
  };

  toggleSelectRow = data => {
    const { cars, onSelectedRowsChange } = this.props;
    let { selectedRows } = this.props;

    const foundIndex = selectedRows.findIndex(selected => selected.id === data.id);
    if (foundIndex === -1) {
      selectedRows.push(data);
    } else {
      selectedRows.splice(foundIndex, 1);
    }
    onSelectedRowsChange(selectedRows);

    const dataSource = this.buildDataSourceWithKeys(cars);
    const selectedRowKeys = this.buildSelectedRowKeys(dataSource, selectedRows);
    this.setState({ selectedRowKeys });
  };

  buildPagination = () => {
    const dataSource = this.buildDataSourceWithKeys(this.props.cars);
    const pageSize = this.helperPageSize();
    const pagination = {
      total: dataSource.length,
      defaultCurrent: 1,
      current: 1,
      // hideOnSinglePage: true,
      pageSize,
      simple: true,
      size: 'small',
      onChange: this.onPageChange
    };
    const start = 1;
    const end = Math.min(pagination.pageSize, pagination.total);

    const paginationText = this.helperPaginationText(start, end, dataSource.length);
    this.setState({
      dataSourceBuffer: dataSource,
      pageSize,
      pagination: { ...pagination },
      paginationText
    });
  };

  onPageChange = (page, pageSize) => {
    const dataSource = this.buildDataSourceWithKeys(this.props.cars);
    const { pagination } = this.state;
    const start = (page - 1) * pageSize + 1;
    const end = Math.min(page * pageSize, pagination.total);
    console.info(page, start, end)
    let paginationText = this.helperPaginationText(start, end, dataSource.length);
    this.setState({
      dataSourceBuffer: dataSource,
      pagination: { ...pagination, current: page },
      paginationText
    });
  };

  render() {
    const { cars, group, selectedRows, commonStore, translationsStore, groupsStore } = this.props;

    const dataSource = this.buildDataSourceWithKeys(cars);
    const selectedRowKeys = this.buildSelectedRowKeys(dataSource, selectedRows);

    let checkmarkHeaderClassName = 'CheckmarkHeader';
    if (selectedRowKeys.length > 0 && selectedRowKeys.length === dataSource.length) {
      checkmarkHeaderClassName = `${checkmarkHeaderClassName} CheckmarkHeaderSelected`;
    } else if (selectedRowKeys.length > 0) {
      checkmarkHeaderClassName = `${checkmarkHeaderClassName} CheckmarkHeaderIndeterminate`;
    }

    const columns = [
      {
        key: 'checkmark',
        dataIndex: 'checkmark',
        title: (
          <div className={checkmarkHeaderClassName} onClick={this.toggleSelectAllRows}>
            <span className="checkmark" />
          </div>
        ),
        render: (text, record) => {
          const checked = selectedRowKeys.findIndex(element => element === record.key) !== -1;
          return (
            <div className={`Checkmark${checked ? ' CheckmarkSelected' : ''}`} onClick={() => this.toggleSelectRow(record)}>
              <span className="checkmark" />
            </div>
          );
        }
      },
      {
        key: 'make',
        dataIndex: 'make',
        title: translationsStore.translate('groupsManager.vehicleTable.headerLabels.make'),
        render: (text, record) => record.make.descrizione
      },
      {
        key: 'model',
        dataIndex: 'model',
        title: translationsStore.translate('groupsManager.vehicleTable.headerLabels.model'),
        render: (text, record) => record.model.descrizione
      },
      {
        key: 'driver',
        dataIndex: 'driver',
        title: translationsStore.translate('groupsManager.vehicleTable.headerLabels.driver'),
        render: (text, record) => (record.driver && record.driver !== null ? record.driver.name : '-')
      },
      {
        key: 'group',
        dataIndex: 'group',
        title: translationsStore.translate('groupsManager.vehicleTable.headerLabels.group'),
        render: (text, record) => (record.groupId !== null ? (groupsStore.groups.find((group) => group.id === record.groupId) || { name: '-' }).name : '-'),
      },
      {
        key: 'plate',
        dataIndex: 'plate',
        className: 'ColumnCentered',
        title: translationsStore.translate('groupsManager.vehicleTable.headerLabels.plate'),
        render: (text, record) => <CarPlateField record={record} />
      },
      {
        key: 'alimentation',
        dataIndex: 'alimentation',
        className: 'ColumnCentered',
        title: translationsStore.translate('groupsManager.vehicleTable.headerLabels.engineFuel'),
        render: (text, record) => translationsStore.translate(`alimentation.${record.alimentation}`)
      },
      {
        key: 'firstRegistrationDate',
        dataIndex: 'firstRegistrationDate',
        className: 'ColumnCentered',
        title: translationsStore.translate('groupsManager.vehicleTable.headerLabels.registrationDate'),
        render: (text, record) => moment(record.firstRegistrationDate).format('DD/MM/YYYY')
      },
      {
        key: 'odometer',
        dataIndex: 'odometer',
        className: 'ColumnCentered',
        title: translationsStore.translate('groupsManager.vehicleTable.headerLabels.odometer'),
        render: (text, record) => {
          let odometer;
          if (record.odometer && record.odometer.value) {
            odometer = Number(record.odometer.value).toFixed(0);
          } else if (record.gpsOdometer && record.gpsOdometer.value) {
            const { initialOdometer, gpsOdometer, gpsOdometerOnDisconnection } = record;
            odometer = Number(odometerHelper.computeOdometer({ initialOdometer, gpsOdometer, gpsOdometerOnDisconnection })).toFixed(0);
          }
          if (odometer === undefined && record.initialOdometer) {
            odometer = record.initialOdometer;
          }
          return odometer !== undefined ? `${Math.round(odometer).toLocaleString()} km` : '-';
        }
      }
    ];

    if(group !== undefined) {
      columns.push({
        key: 'action',
        className: 'ColumnCentered',
        title: '',
        render: (text, record) =>
          <Button
            className='button'
            onClick={() => {this.setState({confirmVisible: true, carToRemove: record})}}
          >
            {translationsStore.translate('groupsManager.removeFromGroup.buttonLabel')}
          </Button>
      })
    }

    return (
      <div className="ClientsTable">
        <Table
          // rowSelection={rowSelection}
          columns={columns}
          dataSource={dataSource}
          pagination={this.state.pagination}
          rowClassName="ClientRow"
        />
        {!commonStore.loading && (
          <div className="ClientsTablePagination">
            <div>{this.state.paginationText}</div>
            {dataSource.length > this.helperPageSize() && <Pagination {...this.state.pagination} />}
            <AirModal
              // className="AddToGroupModal"
              icon={<CarsQueueIcon style={{ width: '60px', height: '40px' }} />}
              okButton={<AirButton disabled={this.state.removeLoading} size="large" light label={translationsStore.translate('groupsManager.removeFromGroup.modal.okLabel')} />}
              cancelButton={<AirButton disabled={this.state.removeLoading} size="large" light label={translationsStore.translate('groupsManager.removeFromGroup.modal.cancelLabel')} />}
              title={translationsStore.translate('groupsManager.removeFromGroup.modal.title')}
              subtitle={translationsStore.translate('groupsManager.removeFromGroup.modal.subtitle')}
              visible={this.state.confirmVisible}
              onCancel={() => this.setState({
                confirmVisible: false,
                carToRemove: undefined
              })}
              onOk={this.handleRemoveCarFromGroup}
              confirmLoading={this.state.removeLoading}
            >

            </AirModal>
          </div>
        )}
      </div>
    );
  }
}

export default withWindowSize(ClientsTable);



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/ClientsWithGroups/ClientsTable/ClientsTable.js